import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import {INITIAL_FLOW_BUTTON_TYPES} from "../../../reducers/initialFlowReducer";
import {setInitialFlowType} from "../../../actions/initialFlowFunctions";


const MaterialsMainCanvasLayoutButton = (props) => {

  const {visualizerNotAvailable, history, setInitialFlowType, showHomeButton, showGalleryButton} = props;

  if (!document.kvConfig.initialFlowEnabled || visualizerNotAvailable) {
    return null
  }

  const handleToggleLayout = () => {
    setInitialFlowType(INITIAL_FLOW_BUTTON_TYPES.Quote);
    history.push("layout");
  };

  return (
    <button className={"selection-main__image-button selection-main__image-button--layout"
      + (showHomeButton ? " selection-main__image-button--layout--with-home" : "")
      + (showGalleryButton ? " selection-main__image-button--layout--with-gallery" : "")}
            onClick={handleToggleLayout}/>
  )

};

const mapStateToProps = (store) => {
  const {visualizerNotAvailable} = store.initialFlowState;

  return {
    visualizerNotAvailable,
  };
};

const mapDispatchToProps = {
  setInitialFlowType
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MaterialsMainCanvasLayoutButton)
)
